import type { DndProviderProps } from "react-dnd";

type DndBackendFactory = Extract<
  DndProviderProps<unknown, unknown>,
  { backend: unknown }
>["backend"];

const unsubscribe = () => {};

const noopDndBackend: DndBackendFactory = (_manager) => ({
  setup() {},
  teardown() {},
  connectDragSource: () => unsubscribe,
  connectDragPreview: () => unsubscribe,
  connectDropTarget: () => unsubscribe,
  profile: () => ({}),
});

export default noopDndBackend;
